import { Accordion, Badge, Card, Col, Row, Tab, Tabs } from 'react-bootstrap';
import { FaCalendarAlt, FaClock, FaEye } from 'react-icons/fa';
// import './ExhibitorAvailSlot.css';
import moment from 'moment';
import { Link } from 'react-router-dom';
import {
  useGetB2BSlotList,
  useReservedSlot,
} from '../../../B2BBuyerSeller/apiEndpoints/b2bBuyerSellerEndpoint';
import {
  calculateDuration,
  groupSlotsByDate,
  groupSlotsByStaffId,
} from '../../../B2BBuyerSeller/B2BProfile/utility/b2bUtility';
import { useState } from 'react';
import PopOver from '../../../../Components/PopOver/PopOver';

function ExhibitorAvailSlot({
  type,
  user_id,
}: {
  type: 'B2B' | 'Exhibitor';
  user_id: number;
}) {
  const { data } = useGetB2BSlotList({
    user_id: user_id as number,
    type: type,
  });

  const { mutate } = useReservedSlot({
    user_id: user_id as number,
    type: type,
  });

  const staffIdWiseGroup = groupSlotsByStaffId(data?.data);

  const [activeKey, setActiveKey] = useState(Object.keys(staffIdWiseGroup)[0]);
  return (
    <>
      <h2 className='text-center mb-4'>
        <FaCalendarAlt className='me-2' />
        Your Available Time Slots
      </h2>
      <Tabs
        id='dynamic-tabs'
        activeKey={activeKey}
        onSelect={(k: any) => setActiveKey(k)}
        className='mb-3'
      >
        {Object?.keys(staffIdWiseGroup)?.map((key, index) => (
          <Tab
            eventKey={key}
            title={`Staff (${staffIdWiseGroup[key][0].staff_name}) -${
              index + 1
            }`}
            key={key}
          >
            <div>
              {staffIdWiseGroup[key]?.length > 0 ? (
                <>
                  {groupSlotsByDate(staffIdWiseGroup[key]) &&
                  Object?.keys(groupSlotsByDate(staffIdWiseGroup[key]))
                    ?.length === 0 ? (
                    <Card className='text-center p-4 no-slots-card'>
                      <p className='text-muted'>No time slots created yet</p>
                    </Card>
                  ) : (
                    <Accordion
                      defaultActiveKey={
                        groupSlotsByDate(staffIdWiseGroup[key]) &&
                        Object?.keys(groupSlotsByDate(staffIdWiseGroup[key]))[0]
                      }
                      flush
                    >
                      {groupSlotsByDate(staffIdWiseGroup[key]) &&
                        Object?.entries(
                          groupSlotsByDate(staffIdWiseGroup[key])
                        )?.map(([date, dateSlots]) => (
                          <Accordion.Item
                            eventKey={date}
                            key={date}
                            className='mb-3 date-card'
                          >
                            <Accordion.Header>
                              <div className='d-flex justify-content-between w-100 pe-3'>
                                <div>
                                  <FaCalendarAlt className='me-2 text-primary' />
                                  <strong>
                                    {moment(date)?.format('dddd, MMM D, YYYY')}
                                  </strong>
                                </div>
                                <Badge bg='primary' pill>
                                  {dateSlots.length} slot
                                  {dateSlots.length !== 1 ? 's' : ''}
                                </Badge>
                              </div>
                            </Accordion.Header>
                            <Accordion.Body>
                              <Row>
                                {dateSlots?.map((slot) => (
                                  <Col
                                    key={slot.id}
                                    md={6}
                                    lg={4}
                                    className='mb-3'
                                  >
                                    <Card className='time-slot-card h-100'>
                                      <div className='p-2'>
                                        <div className='d-flex align-items-center mb-2'>
                                          <FaClock className='me-2 text-secondary' />
                                          <h5 className='mb-0'>
                                            {moment(slot.start_time).format(
                                              'hh:mm A'
                                            )}{' '}
                                            -{' '}
                                            {moment(slot.end_time).format(
                                              'hh:mm A'
                                            )}
                                          </h5>
                                        </div>
                                        <p className='text-muted mb-3'>
                                          Duration:{' '}
                                          {calculateDuration(
                                            slot.start_time,
                                            slot.end_time
                                          )}
                                        </p>

                                        <div>
                                          <div className='d-flex justify-content-between'>
                                            <span className='pointer'>
                                              {slot.is_available === 0 &&
                                                slot.is_reserved === 0 && (
                                                  <Badge>Booked</Badge>
                                                )}
                                            </span>
                                            <Link
                                              to={
                                                slot.type === 'B2B'
                                                  ? `/b2b/other-b2b-slot-list?slot_id=${slot.id}`
                                                  : `/profile/meeting-request?slot_id=${slot.id}`
                                              }
                                              className='text-decoration-none'
                                            >
                                              <FaEye className='me-1' />
                                            </Link>
                                          </div>
                                          {slot.is_available === 1 &&
                                            slot.is_reserved === 0 && (
                                              <div className='pointer'>
                                                <PopOver
                                                  title='Are you sure to reserved this ?'
                                                  confirm={() =>
                                                    mutate({
                                                      is_reserved:
                                                        slot.is_reserved === 0
                                                          ? 1
                                                          : 0,
                                                      slot_id: slot.id,
                                                    })
                                                  }
                                                  children={
                                                    <Badge
                                                      style={{ width: '100%' }}
                                                    >
                                                      Want to Reserve?
                                                    </Badge>
                                                  }
                                                />
                                              </div>
                                            )}
                                          {slot.is_available === 0 &&
                                            slot.is_reserved === 1 && (
                                              <div
                                                // onClick={() =>
                                                //   mutate({
                                                //     is_reserved:
                                                //       slot.is_reserved === 0
                                                //         ? 1
                                                //         : 0,
                                                //     slot_id: slot.id,
                                                //   })
                                                // }
                                                className='text-muted pointer text-center'
                                                style={{
                                                  background: '#e3e3e3',
                                                  color: 'black',
                                                  padding: '2px',
                                                  borderRadius: '5px',
                                                  width: '100%',
                                                }}
                                              >
                                                Reserved
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                    </Card>
                                  </Col>
                                ))}
                              </Row>
                            </Accordion.Body>
                          </Accordion.Item>
                        ))}
                    </Accordion>
                  )}
                </>
              ) : (
                <p>No items available for this tab.</p>
              )}
            </div>
          </Tab>
        ))}
      </Tabs>
    </>
  );
}

export default ExhibitorAvailSlot;
